import api from './api';
import { LoginCredentials, AuthResponse } from '../types/auth.types';

const TOKEN_KEY = 'token';

export const authService = {
  // Вход в систему
  async login(credentials: LoginCredentials): Promise<AuthResponse> {
    const response = await api.post<AuthResponse>('/auth/login', credentials);
    const { access_token } = response.data;

    // Сохраняем только токен
    this.setToken(access_token);

    return response.data;
  },

  // Выход из системы
  logout(): void {
    localStorage.removeItem(TOKEN_KEY);
  },

  // Получить текущий токен
  getToken(): string | null {
    return localStorage.getItem(TOKEN_KEY);
  },

  // Установить токен
  setToken(token: string): void {
    localStorage.setItem(TOKEN_KEY, token);
  },

  // Проверить, авторизован ли пользователь
  isAuthenticated(): boolean {
    return !!this.getToken();
  },
};
